<!-- Card « Acteurs par défaut » au-dessus de l'arbre, comme l'ancien écran (mt-6 : même respiration
     sous les bandeaux que les autres onglets, cf. default-supervision-tree « card mt-6 ») -->
<div class="card mt-6">
  <div class="px-gutter py-4 border-b">
    <h2 class="title m-0">{{ defaultNodeLabel }}</h2>
  </div>
  <div class="px-gutter py-4">
    <purchase-actor-node-editor
      layout="grid"
      [scope]="scope"
      [establishment]="establishment"
      [modifyPermissions]="modifyPermissions"
      [category]="null"
      [childrenCount]="dataSource?.data?.length ?? 0"
      (saved)="onDefaultSaved()"
    ></purchase-actor-node-editor>
  </div>
</div>

<div class="flex flex-row items-stretch gap-6 mt-6">
  <!-- Colonne gauche : arbre des familles (chargé en une fois, filtré par la recherche) -->
  <div class="pa-tree-panel w-1/3 max-w-xs card overflow-auto p-4">
    <mat-progress-bar *ngIf="loadingTree" mode="indeterminate" color="primary"></mat-progress-bar>

    <!-- Recherche de famille : filtre l'arbre pendant la saisie (familles trouvées surlignées,
         leurs parentes dépliées, le reste masqué). -->
    <form [formGroup]="familySearchForm" class="pa-family-search">
      <base-form-input
        label="Rechercher une famille"
        controlName="familySearch"
        type="text"
        appearance="outline"
        [icon]="icSearch"
        [withoutPadding]="true"
      ></base-form-input>
      <p class="text-secondary text-xs mt-2" *ngIf="searchHasNoResult">
        Aucune famille ne correspond à cette recherche.
      </p>
    </form>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="pa-tree">
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        class="pa-tree-node cursor-pointer"
        [class.pa-tree-node--selected]="isNodeSelected(node)"
        [class.pa-tree-node--hidden]="isNodeHidden(node)"
        (click)="selectCategory(node)"
      >
        <span class="pa-tree-node-leaf">
          <ng-container *ngTemplateOutlet="familyLabel; context: { $implicit: node }"></ng-container>
        </span>
        <span class="pa-dot" *ngIf="isConfigured(node)" title="Configuration explicite"></span>
      </mat-tree-node>

      <mat-nested-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        [class.pa-tree-node--hidden]="isNodeHidden(node)"
      >
        <div class="pa-tree-node mat-tree-node" [class.pa-tree-node--selected]="isNodeSelected(node)">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <span class="flex-auto cursor-pointer" (click)="selectCategory(node)">
            <ng-container *ngTemplateOutlet="familyLabel; context: { $implicit: node }"></ng-container>
          </span>
          <span class="pa-dot" *ngIf="isConfigured(node)" title="Configuration explicite"></span>
        </div>
        <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>

    <!-- Libellé d'une famille : découpé en segments (partie trouvée surlignée) pendant une recherche. -->
    <ng-template #familyLabel let-node>
      <ng-container *ngIf="labelSegments(node) as segments; else plainFamilyLabel">
        <span *ngFor="let segment of segments" [class.pa-search-match]="segment.match">{{ segment.text }}</span>
      </ng-container>
      <ng-template #plainFamilyLabel>{{ node.label }}</ng-template>
    </ng-template>
  </div>

  <!-- Colonne droite : résolution par rôle de la famille sélectionnée -->
  <div class="pa-main-panel flex-auto card overflow-auto p-6 flex flex-col">
    <purchase-actor-node-editor
      *ngIf="selectedCategory; else noSelectionTemplate"
      #categoryEditor
      layout="stacked"
      [scope]="scope"
      [establishment]="establishment"
      [modifyPermissions]="modifyPermissions"
      [category]="selectedCategory"
      [childrenCount]="childrenCount"
      (saved)="loadConfiguredNodes()"
    ></purchase-actor-node-editor>

    <ng-template #noSelectionTemplate>
      <!-- flex-auto (et non h-full) : le parent est un flex-col étiré par items-stretch,
           h-full ne se résout pas et laissait l'état vide collé en haut de la carte -->
      <div class="w-full flex-auto flex flex-col justify-center items-center">
        <span class="text-2xl mb-6">Veuillez sélectionner une famille</span>
        <img class="w-full max-w-lg mx-auto mb-6 h-64" src="assets/img/illustrations/checklist.svg" alt="waiting" />
      </div>
    </ng-template>
  </div>
</div>
